
const _ = require('lodash');

export function gamesByOwnerFunc (games) {
  //get games by owner
  const gamesByOwners = [];
  games.forEach((game) => {
    const teamA = game?.team_a[0];
    const teamB = game?.team_b[0];
    let teamObject = [];
    if (gamesByOwners.find(obj => obj.id === teamA?.ownerId)) {
        teamObject = gamesByOwners.find(obj => obj.id === teamA?.ownerId);
        teamObject.games.push(game);
    } else {
      gamesByOwners.push({
        id: teamA?.ownerId,
        name: teamA?.owner,
        games: [game]
      })
    }
    if (gamesByOwners.find(obj => obj.id === teamB?.ownerId)) {
        teamObject = gamesByOwners.find(obj => obj.id === teamB?.ownerId);
        teamObject.games.push(game);
    } else {
      gamesByOwners.push({
        id: teamB?.ownerId,
        name: teamB?.owner,
        games: [game]
      })
    }
  });

  return gamesByOwners;
}

export function scoresOwners(games) {
  const scoresOwners = [];
  games.forEach((game) => {
    const teamA = game?.team_a[0];
    const teamB = game?.team_b[0];
    scoresOwners.push({
      name: teamA.name,
      score: teamA.score,
      id: teamA.ownerId,
      week: game.week,
      year: game.year
    });
    scoresOwners.push({
      name: teamB.name,
      score: teamB.score,
      id: teamB.ownerId,
      week: game.week,
      year: game.year
    });
  });

  return scoresOwners;

}


function cntConsecutiveElements(array) {
  let result = []
  let counter = 1;
  for (let i = 0; i < array.length; i++) {

    if (array[i] === array[i + 1]) {
      counter++;
    } else {
      result.push({
        i,
        type: array[i],
        start: i+2-counter,
        end: i+1,
        streak: counter
      });
      counter = 1;
    }
  }
  return result;
}

export function seasonOutcome(games,id,year,includePlayoffs) {
 
  let wins = 0;
  let loses = 0;
  let ties = 0;
  let scoreFor = 0;
  let scoreAgaisnt = 0;
  let gamelog = [];
  let filteredGames = games;

  if (!includePlayoffs) {
    filteredGames = games.filter(function (game) {
      return game.playoffTierType === "NONE";
    });  
  }

  filteredGames.forEach((game,index) => {
    const teamA = game?.team_a[0];
    const teamB = game?.team_b[0];
    const teamAScore = parseFloat(teamA.score);
    const teamBScore = parseFloat(teamB.score);
    if  (teamBScore === teamAScore) {
      ties++
      gamelog.push('T');
    }
    if (id === teamA.ownerId) {
      if (teamAScore > teamBScore) {
        wins++;
        gamelog.push('W');
      }
      else if (teamBScore > teamAScore) {
        loses++;
        gamelog.push('L');
      }
      scoreFor += teamAScore;
      scoreAgaisnt += teamBScore;
    }
    else if (id === teamB.ownerId) {
      if (teamAScore > teamBScore) {
        loses++;
        gamelog.push('L');
      }
      else if (teamBScore > teamAScore) {
        wins++;
        gamelog.push('W');
      }
      scoreFor += teamBScore;
      scoreAgaisnt += teamAScore;
    }

  });

  console.log(cntConsecutiveElements(gamelog),"consecutives");

  return {
    id,
    year,
    wins,
    loses,
    gamelog,
    pct:  parseFloat(((wins + (ties * .5))/filteredGames.length).toFixed(3)),
    avgPoints: parseFloat((scoreFor/filteredGames.length).toFixed(2)),
    avgPointsAgaisnt: parseFloat((scoreAgaisnt/filteredGames.length).toFixed(2)),
    scoreFor: parseFloat(scoreFor.toFixed(2)),
    scoreAgaisnt: parseFloat(scoreAgaisnt.toFixed(2)),
  }

}

export function gameOutcomeWinner(game,owners) {

  let winner, winnerId, loser, loserId, scoreWin, scoreLose;
  winner = winnerId = loser = loserId = '';
  scoreWin = scoreLose = 0;
  const teamA = game?.team_a[0];
  const teamB = game?.team_b[0];
  const teamAScore = parseFloat(teamA.score);
  const teamBScore = parseFloat(teamB.score);

  if (teamAScore > teamBScore) {
    winnerId = teamA.ownerId;
    scoreWin = teamA.score;
    loserId = teamB.ownerId;
    scoreLose = teamB.score;
    winner = _.find(owners, ['id', winnerId]).name;
    loser = _.find(owners, ['id', loserId]).name;
  }
  else if (teamBScore > teamAScore) {
    winnerId = teamB.ownerId;
    scoreWin = teamB.score;
    loserId = teamA.ownerId;
    scoreLose = teamA.score;
    winner = _.find(owners, ['id', winnerId]).name;
    loser = _.find(owners, ['id', loserId]).name;
  }

  if (winner !== '') {
    return {
      winner: winner,
      loser: loser,
      winnerId: winnerId,
      loserId: loserId,
      scoreWin: scoreWin,
      scoreLose: scoreLose,
      week: game.week,
      year: game.year,
      margin: parseFloat((scoreWin - scoreLose).toFixed(2)),
      sumScore: parseFloat((scoreWin + scoreLose).toFixed(2))
    };
  }
}

export function minus(a, b) {
  return a - b;
}

export function multiply(a, b) {
  return a * b;
}

export function divide(a, b) {
  return a / b;
}
